<template>
    <v-layout wrap>
        <progress-overlay :Loading="Loading"></progress-overlay>
        <v-dialog v-model="deleteDialog" persistent max-width="400px" @keydown.esc="deleteDialog = false">
            <v-card>
                <v-toolbar dense flat>
                    <v-toolbar-title>Delete Cohort</v-toolbar-title>
                </v-toolbar>
                <v-card-text>Are you sure you want to delete this {{deletingcohortName}}?</v-card-text>
                <v-card-actions class="pt-0">
                    <v-spacer></v-spacer>
                    <v-btn small dark color="blue darken-3" @click.native="deleteCohort">Yes</v-btn>
                    <v-btn small dark color="grey darken-1" @click.native="deleteDialog = false">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-flex v-for="(userSetting, index) in userSettingData" :key="index" xs12 d-flex class="ma-0 pa-0 pl-2">
            <v-flex xs7 class="ma-0 pa-0 pl-2">
                <v-switch :label="userSetting.settingName"
                          :input-value="userSetting.showOnDefault"
                          v-model="userSetting.showOnDefault"
                          color="success"
                          :disabled='disabledFunc(userSettingData) && !userSetting.showOnDefault'
                          @change="onCheckboxChange"
                          class="ma-0 pa-0">
                </v-switch>
            </v-flex>
            <v-flex xs1 class="ma-0 pa-0 pl-2">
                <v-tooltip right>
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" small icon class="ma-0 pa-0" @click="editCohort(userSetting.userSettingId,userSetting.settingName)"><v-icon color="primary">edit</v-icon></v-btn>
                    </template>
                    <span>
                        Edit Cohort.
                    </span>
                </v-tooltip>
            </v-flex>
            <v-flex xs1 class="ma-0 pa-0 pl-3">
                <v-tooltip right>
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" small icon class="ma-0 pl-0" @click="deleteCohortDialog(userSetting.userSettingId,userSetting.settingName)"><v-icon>delete_forever</v-icon></v-btn>
                    </template>
                    <span>
                        Delete Cohort.
                    </span>
                </v-tooltip>
            </v-flex>
            <v-flex xs1 class="ma-0 pa-0 pl-4">
                <v-tooltip right>
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" small icon class="ma-0"><v-icon>info</v-icon></v-btn>
                    </template>
                    <span>
                        Selected Cohort Filters:
                        <br />
                        <span v-for="(filter,index) in userSetting.itemValues" :key="index">
                            <span>
                                {{filter.category}} : {{ filter.itemName }}
                            </span>
                            <br />
                        </span>
                    </span>
                </v-tooltip>
            </v-flex>
        </v-flex>
        <CohortUpdate :Dialog="dialog"
                      :CategoriesSegment="CategoriesSegment"
                      :newCohort="false"
                      :CohortName="editingCohortName"
                      :CohortID="editingCohortId"
                      v-on:cancelDialog="cancelDialog"></CohortUpdate>
    </v-layout>
</template>
<script>
    import { mapState } from 'vuex';
    import CohortUpdate from './CohortUpdate'
    import ProgressOverlay from '../_partial/ProgressOverlay'

    export default {
        components: {
            CohortUpdate,
            ProgressOverlay
        },
        //props: ['userSettingData'],
        data() {
            return {
                deleteDialog: false,
                editingCohortName: '',
                dialog: false,
                editingCohortId: null,
                deletingCohortId: null,
                deletingcohortName: '',
                Loading: false
            }
        },
        computed: {
            ...mapState({
                CategoriesSegment: state => state.CategoriesStore.cohortSegmentfilterCategories,
                userSettingData: state => state.UserSettingStore.userSettingData,
                tblCohortFilters: state => state.CategoriesStore.tblCohortFilters,
            }),
            modelCohort: {
                get() {
                    return this.$store.state.CategoriesStore.modelCohort;
                },
                set(newVal) {
                    this.$store.state.CategoriesStore.modelCohort = newVal;
                }
            }
        },
        mounted() {
            //console.log(JSON.stringify(this.userSettingData));
        },
        methods: {
            disabledFunc(x) {
                var count = 0;
                x.map(function (m) {
                    if (m.showOnDefault)
                        count = count + 1;
                });
                if (count >= 3)
                    return true;
                else
                    return false;
            },
            onCheckboxChange() {
                //this.$store.state.UserSettingStore.tblCohortListFilters = this.userSettingData;
                this.$store.state.UserSettingStore.userSettingData = this.userSettingData;
                this.$store.state.CategoriesStore.cohortFiltersApplied = true;

                //this.$store.state.UserSettingStore.modelCohortFilters = this.userSettingData;
                
                  /*  this.userSettingData.filter(function (l) {
                        return l.settingName
                    }).map(function (l) {
                        var userSettingId = l.userSettingId
                        var settingName = l.settingName
                        var showOnDefault = l.showOnDefault
                        return l.itemValues.filter(function (l) {
                            return l.showOnDefault
                        }).map(function (l) {
                            return {
                                userSettingId: userSettingId,
                                settingName: settingName,
                                showOnDefault: showOnDefault,
                                itemValues: [{
                                    category: l.category,
                                    itemName: l.itemName,
                                    itemResponseValue: l.itemResponseValue,
                                }]
                            };
                        })
                    })*/
            },
            getCohortId(userSetting) {
                return "Cohort-" + userSetting.userSettingId;
            },
            editCohort: function (cohortId, cohortName) {
                this.editingCohortId = cohortId;
                this.editingCohortName = cohortName;
                this.dialog = true;
            },
            deleteCohortDialog: function (cohortId, cohortName) {
                this.deletingCohortId = cohortId;
                this.deletingcohortName = cohortName;
                this.deleteDialog = true;
            },
            deleteCohort() {
                this.$store.dispatch('CohortStore/DeleteCohort', this.deletingCohortId)
                    .then(() => {
                      //  this.$store.dispatch('CategoriesStore/resetmodelCohort', this.deletingCohortId);
                        this.$store.dispatch('AppStore/SetAlert', { alert: this.deletingcohortName + ' deleted successfully.', isError: false })
                        this.$store.dispatch('UserSettingStore/getUserSettingData')
                            .then(() => {
                                var selectedUserSettings = [];
                                for (var i = 0; i < this.userSettingData.length; i++) {
                                    if (this.userSettingData[i].showOnDefault) {
                                        var name = this.userSettingData[i].settingName;
                                        let id = this.userSettingData[i].userSettingId;
                                        var userSetting = {
                                            settingName: name,
                                            userSettingId: id,
                                            itemValues: []
                                        }
                                        userSetting.itemValues = this.userSettingData[i].itemValues;
                                        selectedUserSettings.push(userSetting);
                                    }
                                }
                                this.$store.dispatch('UserSettingStore/settblCohortListFilters', selectedUserSettings);

                                var countMeasure = 0
                                for (var k = 0; k < this.tblCohortFilters.length; k++) {
                                    var measure = this.tblCohortFilters[k];
                                    if (measure.categoryName == "Measures") {
                                        countMeasure = this.tblCohortFilters[k].keyValues.length;
                                    }
                                }
                                if (countMeasure > 0) {

                                    this.Loading = true;
                                    this.$store.dispatch('SegmentMeasureStore/resetCompositeQuestionText')
                                    this.$store.dispatch('SegmentMeasureStore/getCompositeQuestionTextForCohort')
                                        .then(() => {
                                        }).catch(error => {
                                            this.Loading = false;
                                            this.$store.dispatch('AppStore/SetAlert', { alert: error, isError: true })
                                        })
                                    this.$store.dispatch('SegmentMeasureStore/GetClientDataWithCohort')
                                        .then(() => {
                                            this.Loading = false;
                                        }).catch(error => {
                                            this.Loading = false;
                                            this.$store.dispatch('AppStore/SetAlert', { alert: error, isError: true })
                                        })
                                }

                            }).catch(error => {
                                console.log(error);
                                this.$store.dispatch('AppStore/SetAlert', { alert: error, isError: true })
                            })

                    }).catch(error => {
                        console.log(error);
                        this.$store.dispatch('AppStore/SetAlert', { alert: error, isError: true })
                    })
                this.deleteDialog = false;
            },
            cancelDialog() {
                this.editingCohortId = 0;
                this.editingCohortName = '';
                this.dialog = false;
            },
            checkIfSelected: function (userSetting) {
                if (this.modelCohort == null || this.modelCohort.length == 0) return false;
                for (var i = 0; i < this.modelCohort.length; i++) {
                    if (this.modelCohort[i] == 'Cohort-' + userSetting.userSettingId) {
                        //console.log('true');
                        return true;
                    }
                }
                //console.log('false');
                return false;
            },
            //toggle(index, value, event) {
            //    console.log(`update ${index} ${value} ${event}`);
            //    var modelObj = {
            //        index: index,
            //        value: event
            //    }
            //    this.$store.dispatch('CategoriesStore/updateModelCohort', { modelObj  })
            //}
        }
    }
</script>
<style scoped>
    .switch {
        float: left;
        margin-top: 2px;
        margin-bottom: 0px;
    }

    .button {
        zoom: 90%;
        margin-top: 5px;
    }
</style>